import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectAllCarImagesFolders, selectDealerMyCarPark, selectDealerProfile } from 'src/app/common/store/state/app.state';
import { DomSanitizer } from '@angular/platform-browser';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { FilesActions } from 'src/app/common/store/actions/files.actions';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { CarEditDialogComponent } from 'src/app/public/car/elements/car-edit/car-edit.component';
import { Car } from 'src/app/public/car/models/car.model';
import { FileData } from 'src/app/public/common/models/file-data.model';

@Component({
    selector: 'app-provider-park',
    templateUrl: './provider-park.component.html',
    styleUrls: ['./provider-park.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProviderParkComponent  implements OnInit {
  
  sessionInfo = "Click to update data";
  
  progressInfos: any[] = [];
  message: string[] = [];

  myCars$: Observable<Car[]>;
  carImagesFolders$: Observable<Map<string, Array<FileData>>>;

  currentSeller$: Observable<Dealer>;
  currentSeller: Dealer = new Dealer();

  constructor(
    private store: Store, 
    private router: Router, 
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog) {
      
      this.myCars$ = store.select(selectDealerMyCarPark);
      this.carImagesFolders$ = store.select(selectAllCarImagesFolders);
      this.currentSeller$ = store.select(selectDealerProfile);
      
      this.currentSeller$.subscribe(
        (seller: Dealer) => {
          this.currentSeller = seller;
        }  
      ); 
    }
  
  ngOnInit(): void {

      this.store.dispatch(DealerActions.fetchProviderParkSubmit());  
      
    }
    
  uploadImage(carId: string, event: any, ): void {
    this.message = [];
    this.progressInfos = [];
    let files: File[] = event.target.files;
    console.log('file name = '+files[0].name);

    if(files != undefined && files.length > 0){
      this.store.dispatch(FilesActions.uploadCarImageSubmit({ carId: carId, file: files[0] }));
    }
  }

  openCarEditDialog(): void {

    let car: Car = new Car();
    car.country = this.currentSeller.countryResident
    car.city = this.currentSeller.cityResident;
    

    const dialogRef = this.dialog.open(CarEditDialogComponent, {
      data: car
    });

    dialogRef.afterClosed().subscribe((result: Car) => {

      //console.log(" result  = "+JSON.stringify(result));
      
      if(result != undefined ){
        //console.log(result)
        
        if(result.carId === ''){
          this.store.dispatch(DealerActions.createNewCarSubmit({ car: result }));
        }
        else{
          this.store.dispatch(DealerActions.updateCarSubmit({ carUpdates: result }));
        }
      }    
    });
  } 
}
